import { Award, Truck, RotateCcw, Zap } from "lucide-react";
import WhatsAppIcon from "@/components/WhatsAppIcon";

const ITEMS = [
  { Icon: Zap, label: "Best Prices Guaranteed" },
  { Icon: Truck, label: "Free Shipping · Pan India" },
  { Icon: Award, label: "Handpicked Luxury" },
  { Icon: RotateCcw, label: "Easy 7-Day Returns" },
  { Icon: WhatsAppIcon, label: "WhatsApp Concierge" },
];

const TrustStrip = () => (
  <div className="border-b border-line bg-white" data-testid="trust-strip">
    <div className="lux-container hidden md:block">
      <ul className="flex items-center justify-center gap-10 py-3 text-[11px] font-semibold tracking-wider uppercase text-ink-soft">
        {ITEMS.map(({ Icon, label }) => (
          <li key={label} className="flex items-center gap-2">
            <Icon className="w-4 h-4 text-pink" strokeWidth={2} />
            <span>{label}</span>
          </li>
        ))}
      </ul>
    </div>
    <div className="md:hidden overflow-hidden py-2 bg-bg-2">
      <div className="marquee">
        <div className="marquee-track">
          {[...ITEMS, ...ITEMS, ...ITEMS].map(({ Icon, label }, i) => (
            <span
              key={i}
              className="flex items-center gap-1.5 text-[10px] font-semibold tracking-wider uppercase text-ink-soft whitespace-nowrap"
            >
              <Icon className="w-3 h-3 text-pink" strokeWidth={2} />
              {label}
            </span>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default TrustStrip;
